import { useSearchDictionary } from '3-foundation/Search/useSearchDictionary';
import dynamic from 'next/dynamic';

const DynamicCludoSearchResults = dynamic(
	() => import('ui/components/10-vendors/cludo/CludoSearchResults/CludoSearchResults').then((module) => module.UI_CludoSearchResults),
	{
		ssr: false,
	},
);

export const CludoSearchResults = ({ heading, searchTag, initialQuery }) => {
	const dictionaryCollection = useSearchDictionary();
	return <DynamicCludoSearchResults heading={heading} dictionary={dictionaryCollection} searchTag={searchTag} initialQuery={initialQuery} />;
};
